(() => {
  'use strict';
  const section = document.querySelector('#build-your-ring');
  if (!section) return;
  const track = section.querySelector('.ring-builder-track');
  const cards = [...section.querySelectorAll('.ring-builder-card')];
  const prev = section.querySelector('[data-ring-prev]');
  const next = section.querySelector('[data-ring-next]');
  const controls = section.querySelector('.ring-builder-controls');
  const selector = section.querySelector('.ring-builder-color-selector');
  const choices = [...selector.querySelectorAll('input[type="radio"]')];
  const label = selector.querySelector('.ring-builder-metal-name');
  const status = selector.querySelector('.ring-builder-color-status');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const previews = cards.map(card => ({
    card,
    image:card.querySelector('.ring-builder-image'),
    links:[...card.querySelectorAll('a')],
    animation:null
  }));
  let current = choices.find(input => input.checked);
  let revision = 0;
  let pending = false;
  const setPending = value => {
    pending = value;
    track.setAttribute('aria-busy', String(value));
    previews.forEach(({links}) => links.forEach(link => {
      if (value) link.setAttribute('aria-disabled', 'true');
      else link.removeAttribute('aria-disabled');
    }));
  };
  previews.forEach(({links}) => links.forEach(link => {
    ['click', 'auxclick'].forEach(eventName => link.addEventListener(eventName, event => {
      if (pending) event.preventDefault();
    }));
  }));
  const select = async input => {
    if (!input.checked) return;
    const request = ++revision;
    if (input === current) {
      setPending(false);
      status.textContent = `${current.dataset.metalLabel} selected for all eight styles.`;
      return;
    }
    setPending(true);
    status.textContent = `Loading ${input.dataset.metalLabel} for all eight styles.`;
    try {
      // Decode every original photo before changing any card or destination.
      await Promise.all(previews.map(({card}) => {
        const image = new Image();
        image.src = card.dataset[`${input.value}Image`];
        return image.decode();
      }));
      if (request !== revision) return;
      previews.forEach(preview => {
        const {card, image, links} = preview;
        image.src = card.dataset[`${input.value}Image`];
        image.alt = `${card.dataset.ringName} ring in ${input.dataset.metalLabel}`;
        links.forEach(link => {
          link.href = card.dataset[`${input.value}DesignUrl`];
          link.setAttribute('aria-label', `Build ${card.dataset.ringName} in ${input.dataset.metalLabel} (opens in a new tab)`);
        });
        if (preview.animation) preview.animation.cancel();
        if (!motion.matches && image.animate) preview.animation = image.animate(
          [{opacity:.55,transform:'rotateY(-12deg)'},{opacity:1,transform:'rotateY(0deg)'}],
          {duration:220,easing:'ease-out'}
        );
      });
      current = input;
      label.textContent = input.dataset.metalLabel;
      status.textContent = `${input.dataset.metalLabel} selected for all eight styles.`;
    } catch (_) {
      if (request !== revision) return;
      choices.forEach(choice => { choice.checked = choice === current; });
      status.textContent = `That color could not load. All eight styles remain in ${current.dataset.metalLabel}. Please try again.`;
    } finally {
      if (request === revision) setPending(false);
    }
  };
  choices.forEach(input => input.addEventListener('change', () => select(input)));
  // Arrow keys and Space retain native radio behavior. Add Home and End.
  selector.addEventListener('keydown', event => {
    if (!choices.includes(event.target) || !['Home','End'].includes(event.key)) return;
    event.preventDefault();
    const input = choices[event.key === 'Home' ? 0 : choices.length - 1];
    input.checked = true;
    input.focus();
    return select(input);
  });
  selector.hidden = false;
  if (motion.addEventListener) motion.addEventListener('change', () => {
    if (motion.matches) previews.forEach(preview => { if (preview.animation) preview.animation.cancel(); });
  });
  const bounds = () => {
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    controls.hidden = end <= 2;
    track.tabIndex = end > 2 ? 0 : -1;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= end - 2;
  };
  const step = () => cards[0].getBoundingClientRect().width + 10;
  const go = target => track.scrollTo({left:target, behavior:motion.matches?'auto':'smooth'});
  prev.addEventListener('click', () => go(track.scrollLeft - step()));
  next.addEventListener('click', () => go(track.scrollLeft + step()));
  track.addEventListener('keydown', event => {
    if (event.target !== track || track.scrollWidth <= track.clientWidth + 2) return;
    const positions = {ArrowLeft:track.scrollLeft-step(), ArrowRight:track.scrollLeft+step(), Home:0, End:track.scrollWidth};
    if (!(event.key in positions)) return;
    event.preventDefault();
    go(positions[event.key]);
  });
  track.addEventListener('scroll', bounds, {passive:true});
  window.addEventListener('resize', bounds);
  if ('ResizeObserver' in window) new ResizeObserver(bounds).observe(track);
  bounds();
})();
